export class ContactDialogClosedEvent {}
